<template>
  <div class="nav_wrap" :style="{ '--background': background }">
    <NavBar :title="title" :border="border" :fixed="fixed" :z-index="zIndex" :placeholder="fixed">
      <Icon v-if="leftArrow" slot="left" name="arrow-left" color="var(--navColor)" @click="leftClick" size="20" />
      <div slot="left" v-else>
        <slot name="left"></slot>
      </div>
      <div slot="title">
        <slot name="title">{{ title }}</slot>
      </div>
      <div slot="right">
        <slot name="right"></slot>
      </div>
    </NavBar>
  </div>
</template>

<script>
import { NavBar, Icon } from 'vant';
export default {
  props: {
    title: {
      type: String,
      default: ""
    },
    leftArrow: {
      type: Boolean,
      default: true
    },
    border: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: true
    },
    zIndex: {
      type: Number,
      default: 1
    },
    background: {
      type: String,
      default: "var(--navTheme)"
    },
    isLeft: Boolean
  },
  components: {
    NavBar, Icon
  },
  data() { return {} },
  methods: {
    leftClick() {
      if(this.isLeft){
        this.$emit('leftClick')
      }else{
        this.$router.back()
      }
    },
  },
  created() { }
}
</script>

<style lang="less" scoped>
.nav_wrap {
  /deep/ .van-nav-bar {
    background: var(--background);
  }

  .van-nav-bar {
    /deep/ .van-nav-bar__content {
      background: var(--background)
    }

  }

  /deep/.van-nav-bar__title {
    color: var(--navColor);
  }
}
</style>